<template>
    <div :class="[ 'auth-wrapper', `auth-wrapper--${pageClass}` ]">
        <router-view /> <!-- Output Authentication View !-->
        <lc-auth-selected-retailers/>
    </div>
</template>

<script>
    import lcAuthSelectedRetailers from 'components/auth/AuthSelectedRetailers'

    export default {
        name: 'authwrapper',
        components: {
            lcAuthSelectedRetailers
        },
        computed: {
            pageClass() {
                return this.$route.name
            }
        },
        mounted() {
            //this.$root.$on('recordAuthAnalytics', this.recordAnalytics)
        },
        methods: {
            /**
             * Run Loyalty Corp's Analytics
             */
            recordAnalytics() {
                if (window.lcAnalytics && typeof window.lcAnalytics.onRouteReady !== 'undefined') {
                    window.lcAnalytics.onRouteReady()
                }
                window.LoyaltyCorp.domEventEmitter.publish('analytics:pageReady')
            }
        }
    }
</script>

<style lang="scss">
    @import 'config';
    @import 'utils/animations';
    @import 'components/auth';
</style>


// WEBPACK FOOTER //
// resources/assets/js/vue/layouts/auth/AuthWrapper.vue